import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getApiService } from '../api/api-request';
import { FeatureFlag, SsoType } from '../../../sharedTypes';

type UpdateMandantParams = {
  featureFlags?: FeatureFlag[];
  id: string;
  scormDownloadEnabled?: boolean;
  ssoType?: SsoType | null;
};

export const useUpdateMandantMutation = (getIdToken: () => Promise<string>) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UpdateMandantParams) => {
      return await getApiService(getIdToken).updateMandant(params);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['mandanten']);
    },
  });
};
